module.exports = __webpack_public_path__ + "img/phone_new.0fe0bc46.svg";